const checkStockCar = (array = []) => {
  if (!array.length) return false;
  for (let i = 0; i < array.length; i++) {
    if (array[i].count >= 1) return true;
  }
  return false;
};

export default checkStockCar;
